import { SITE } from "./site.config";

// Slug helper
export const slugify = (s) =>
  s
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

/*
 * SUBURBS — every service area we mention on the site (used for text mentions,
 * marquee strips, service-area copy). NO suburb gets its own indexable page —
 * per Nov 2026 SEO clean-up we consolidated all suburb doorway pages into
 * /services/auto-electrician-sunshine-coast (the primary geo authority page).
 * Suburb references remain as natural text mentions and are attached to real
 * completed builds where genuinely relevant.
 */
export const SUBURBS = SITE.serviceAreas.map((name) => ({
  name,
  slug: slugify(name),
  region: "Sunshine Coast, QLD",
}));

// No suburb has its own indexable page anymore. All /auto-electrician-<slug>
// routes 301-redirect to /services/auto-electrician-sunshine-coast.
export const INDEXABLE_SUBURB_SLUGS = [];
export const INDEXABLE_SUBURBS = [];

// Every historical suburb slug now redirects to the primary Sunshine Coast page.
export const RETIRED_SUBURB_SLUGS = SUBURBS.map((s) => s.slug);

export const findSuburb = () => null;

export const SUBURB_PATH = (slug) => `/auto-electrician-${slug}`;
